// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import ObjectFitImages from 'object-fit-images';
import 'jquery-match-height';
import Emitter from 'tiny-emitter';
import flatpickr  from 'flatpickr';
import AOS  from 'aos';
import '@fancyapps/fancybox';

import Accordion from '../_modules/atoms/accordion/accordion';
import CustomSelect from '../_modules/atoms/custom-select/custom-select';
import Notification from '../_modules/molecules/notification/notification';
import StandardCarousel from '../_modules/molecules/standard-carousel/standard-carousel';
import SiteHeader from '../_modules/organisms/site-header/site-header';
import HighlightsBanner from '../_modules/organisms/highlights-banner/highlights-banner';
import FeaturedLinks from '../_modules/organisms/featured-links/featured-links';
import Partners from '../_modules/organisms/partners/partners';
import SocialFeed from '../_modules/organisms/social-feed/social-feed';
import PageBanner from '../_modules/organisms/page-banner/page-banner';
import RelatedContent from '../_modules/organisms/related-content/related-content';
import HomeMap from '../_modules/organisms/home-map/home-map';
import Map from '../_modules/organisms/map/map';
import Listing from '../_modules/organisms/listing/listing';
import EventsListing from '../_modules/organisms/events-listing/events-listing';
import NewsListing from '../_modules/organisms/news-listing/news-listing';
import Gallery from '../_modules/organisms/gallery/gallery';
import HeroBanner from '../_modules/organisms/hero-banner/hero-banner';
import Sitemap from '../_modules/organisms/sitemap/sitemap';
import SearchResults from '../_modules/organisms/search-results/search-results';

$(() => {
  let config = {
    breakpoints: {
      tablet: 768, 
      desktop: 1024,
      lgDesktop: 1280
    }
  };

  window.emitter = new Emitter();
  AOS.init({
    duration: 1200
  })
  new ObjectFitImages();

  // if ($('.flatpickr').length) {
  //   new flatpickr();
  // }
  
  new SiteHeader();
  new Notification();

  if ($('.hero-banner').length) {
    new HeroBanner(config);
  }

  if ($('.highlights-banner').length) {
    new HighlightsBanner();
  }

  if ($('.featured-links').length) {
    new FeaturedLinks();
  }

  if ($('.partners').length) {
    new Partners(config);
  }

  if ($('.social-feed').length) {
    new SocialFeed(config);
  }

  if ($('.page-banner__carousel').length) {
    new PageBanner(config);
  }

  if ($('.related-content').length) {
    new RelatedContent(config);
  }

  if ($('.accordion').length) {
    new Accordion($('.accordion'));
  }

  if ($('.standard-carousel').length) {
    new StandardCarousel();
  }

  if($('.standard-aside').length) {
    $('.custom-select').map((i, ele) => {
      new CustomSelect($(ele));
    });
  }

  if($('.home-map').length) {
    new HomeMap();
  }

  if ($('.map').length) {
    new Map();
  }

  if($('.listing').length) {
    new Listing();
  }

  if($('.news-listing').length) {
    new NewsListing();
  }

  if($('.events-listing').length) {
    new EventsListing();
  }

  if($('.gallery').length) {
    new Gallery(config);
  }

  if($('.sitemap').length) {
    new Sitemap();
  }

  if($('.search-results').length) {
    new SearchResults();
  }

  // TO REMOVE
  // if ($('.all-modules').length) {
  //   $('.custom-select').map((i, ele) => {
  //     new CustomSelect($(ele));
  //   });

  //   var startPicker = flatpickr("#start-date", {
  //     onChange: function(selectedDates, dateStr, instance) {
  //       endPicker.set('minDate', selectedDates[0]);
  //     }
  //   });
  //   var endPicker = flatpickr("#end-date", {});
  // }

});
